export enum FinanceValidationFormEnum {
  'payment-proof' = 'payment-proof',
  'total-ammount' = 'total-ammount',
}

export interface ModalFinanceValidationProps {
  isOpen: boolean
  form: FinanceValidationFormEnum
  saleOrderUuid?: string
  onClose: (forceSubmit?: boolean) => void
}
